<template>
  <v-container fluid id="aboutus" xstyle="display: none;">
    <div class="van-hairline--bottom van-nav-bar font_weight_bold" style="z-index: 1;">
      <div class="van-ellipsis van-nav-bar__title" v-if="this.show_content == 'About Us'">
        {{ $t("aboutus.title") }}
      </div>
      <div class="van-ellipsis van-nav-bar__title" v-else-if="this.show_content == 'Shipping Information'">
        Shipping Information
      </div>
      <div class="van-ellipsis van-nav-bar__title" v-else-if="this.show_content == 'Returns & Exchanges'">
        Returns & Exchanges
      </div>
    </div>

    <div class="aboutUsContainer">
      <van-sidebar v-model="activeKey" class="sidebar">
        <van-sidebar-item v-for="item in ['About Us', 'Shipping Information', 'Returns & Exchanges']" :key="item" :title="item"
          @click="onClickChangeContent(item)" />
        <van-sidebar-item v-show="iOS_device" title="iOS Tips" @click="onClickIOSTips" />
      </van-sidebar>

      <div v-if="this.show_content == 'About Us'" class="box">
        <div class="spacer20"></div>
        <div class="body1">
          <div class="header1">
            About Baby Bryan Store
          </div>
          <div class="spacer20"></div>
          <p>
            In August 2014 , our first child Bryan was born. Since we became parents, we found that baby needs lots of daily products. We need to do
            lots of research before purchasing these baby items. We believe many parents are suffering the same problems like us. So we decide to open
            an one-stop baby shop for new parents as well as experienced parents for their baby's needs. In this store, our team choose best baby item
            all over the world for different parents. We narrow the options for the same type of products with higher quality and design to save your
            time.
          </p>
          <ul class="list">
            <li>AUGUST 2015, BABY BRYAN FIRST STORE OPEN AT MARKHAM</li>
            <li>JANUARY 2017, OUR 2300 SQF WAREHOUSE WAS PUT INTO OPERATION</li>
            <li>JULY 2020, BABY BRYAN SECOND STORE OPEN AT FAIRVIEW MALL</li>
            <li>AUGUST 2020, MOVE TO A 5000 SQF WAREHOUSE</li>
            <li>SEPTEMBER 2020, BABY BRYAN APP AND NEW WEBSITE LAUNCHED</li>
            <li>OCTOBER 2020, BABY BRYAN MARKHAM LOCATION MOVE TO A BIGGER UNIT</li>
          </ul>

          <div class="spacer20"></div>
          <v-row>
            <v-col cols="12" sm="6" md="3" v-for="(item, index) in aboutUsImages" :key="index">
              <img v-lazy="item" />
            </v-col>
          </v-row>
          <div class="spacer20"></div>

          <div class="header1">
            Locations & Hours:
          </div>
          <div class="spacer10"></div>

          <v-row>
            <v-col cols="12" md="6">
              <div class="header2" style="margin-left: 20px;">
                Baby Bryan ( Markham )
              </div>
              <div class="spacer10"></div>
              <ul>
                <li>Store Address:</li>
                <li>3985 Highway7, Unit 101,</li>
                <li>Markham, Ontario, L3R 2A2</li>
                <div class="spacer10"></div>
                <li>Business Hours:</li>
                <li>• Monday ~ Friday: 10:00 A.M. to 7:00 P.M.</li>
                <li>• Saturday ~ Sunday: 11:00 A.M. to 6:00 P.M.</li>
                <div class="spacer10"></div>
              </ul>
            </v-col>
            <v-col cols="12" md="6">
              <div class="header2" style="margin-left: 20px;">
                Baby Bryan ( Fairview Mall )
                <!-- <div style="color:red">(Temporarily Closed)</div> -->
              </div>
              <div class="spacer10"></div>
              <ul>
                <li>Store Address:</li>
                <li>1800 Sheppard Ave. East,</li>
                <li>Toronto, Ontario, M2J 5A7</li>
                <div class="spacer10"></div>
                <li>Business Hours:</li>
                <li>• Monday ~ Saturday: 10:00 A.M. to 9:00 P.M.</li>
                <li>• Sunday: 11:00 A.M. to 7:00 P.M.</li>
                <div class="spacer10"></div>
              </ul>
            </v-col>
          </v-row>
          <div class="spacer20"></div>

          <div class="header1">
            Contact Information:
          </div>
          <div class="spacer10"></div>
          <ul>
            <li>Markham Number: (647) 560-6382</li>
            <li>Fairview Mall Number: (416) 491-2229</li>
            <li>Email: <a>info@babybryan.ca</a></li>
            <li>Markham Email: <a>babybryan2015@hotmaill.com</a></li>
            <li>Fairview Mall Email: <a>babybryanfairview@hotmail.com</a></li>
            <li>Wechat: babybryan2022</li>
          </ul>
        </div>
      </div>
      <div v-else-if="this.show_content == 'Shipping Information'" class="box">
        <div class="spacer20"></div>
        <div class="body1">
          <div class="header1">
            Shipping Information
          </div>
          <div class="spacer20"></div>
          <p>
            *Please note all shipping fees incurred when sending the order out are non-refundable and customer is responsible for return costs.
          </p>
          <p>
            Refuse shipments and shipments not picked up at shipping depots on time are considered returns and are subject to return shipping charges.
          </p>
          <p>
            Your order may ship with Canada Post, FedEx, Purolator or UPS. Deliveries are made Monday to Friday. If you require a weekend delivery,
            please contact our Customer Service before you order.
          </p>
          <p>
            All in-stock items are shipped within 1-3 business days (Monday - Friday), due to higher than normal order volumes during sales period,
            our shipping times may increase, and you may not be notified of any delay. At this moment, all orders are only shipped within Canada. If
            there is an issue with delivery times or availability, our customer service will contact you by phone or via email within 48 hours to
            discuss the shipping and delivery options. You will receive e-mail with tracking information once your order has shipped.
          </p>
          <p>
            If there are any discrepancies with shipping amounts (or over-sized items that require shipping charges to be calculated after the order
            has been placed), a customer service representative will contact you via phone or email to discuss price changes or shipping options. If
            no shipping amount at all shows on your over-sized item (such as furniture and mattresses), a customer service representative will contact
            you via phone or email with the shipping amount.
          </p>
          <p>
            In order to arrange a re-delivery, delivery charges will need to be paid again by the purchaser. Please note that all deliveries are
            shipped without "signature required". Please contact our Customer Service before you order if you require “signature” option!
          </p>
          <p>
            All claims for damages / defects must be submitted in writing to <a>info@babybryan.ca</a> within 48 hours of receiving the goods. Any
            order discrepancies need to be reported to <a>info@babybryan.ca</a> within 72 hours of receiving the goods.
          </p>
          <div class="spacer20"></div>
          <div class="header1">
            FREE SHIPPING* when you spend $99 (pre-tax) or more
          </div>
          <div class="spacer20"></div>
          <p>
            As a thank you for shopping with Baby Bryan we are pleased to offer Free Shipping for all online orders over $99 (before taxes). Orders
            that qualify for Free Shipping will be sent via standard service.
          </p>
          <p>
            "Free Shipping" offer excludes oversized items such as; diapers, bath tubs, diaper pails, clearance items and all furniture items, such
            as; playrooms, playmats, toys storage, bookshelves，sofas，chairs, cribs, beds, dressers, night tables, beanbags, all mattresses; twin,
            full and crib sized, etc. These items will be noted in the product description. Free Shipping discount is not applicable with returned
            merchandise. This offer is not valid on previous purchases. This promotional offer may be modified or terminated at any time without
            notice. We reserve the right to cancel any order due to unauthorized, altered, or ineligible use of a discount. Baby Bryan reserves the
            right to cancel and/ or not ship an order at any time.
          </p>
          <p>
            Shipping charges are based on our shipping partner's locations. If your location is outside of their shipping areas there may be
            additional shipping charges that were not calculated with your initial order. This applies to orders that have received Free Shipping as
            well as those below the free shipping threshold. We will do our best to find a shipping rate that will work within the parameters of what
            was estimated but some items (oversized items shipping to rural areas, shipping to northern parts of the province, etc) are unable to be
            calculated by the system and need to be manually calculated by our customer service team member. We apologize for any inconvenience that
            this may cause, and we will contact you as quickly as possible with shipping options.
          </p>
          <p>
            *All furniture deliveries are a curbside (first threshold) delivery service. For more information on our furniture delivery or to inquire
            about additional delivery options please contact our Customer Service team at <a>info@babybryan.ca</a>
          </p>
          <div class="spacer20"></div>
          <div class="header1">
            Cancellation Policy
          </div>
          <div class="spacer20"></div>
          <p>
            With our commitment to process online orders quickly, cancellation requests must be submitted as soon as possible before we ship.
          </p>
          <p>
            Please contact us by phone or e-mail <a>info@babybryan.ca</a> with your cancellation requests. We will notify you if your order is
            eligible.
          </p>
          <div class="spacer20"></div>
          <div class="header1">
            Exceptions
          </div>
          <div class="spacer20"></div>
          <p>Some areas are excluded from our Free Shipping policy. Free Shipping is eligible for orders shipping within Canada.</p>
          <p>These exception areas include: Yukon, Northwest Territories, Nunavut & the following postal codes:</p>
          <ul class="list">
            <li>British Columbia: V0W, V0C, V0T, V0J, V8J, V0V, V8G, V8C, V0T, V1J, V1G, V0E, V0A, V0B, V0K, V0N</li>
            <li>Manitoba: R0B, R8N, R8A, R9A, R0L</li>
            <li>Alberta: T0H, T8S, T0G, T0A, T0P, T0C, T0J</li>
            <li>Saskatchewan: S0M, S0J, S9X, S0P, S0E, S0L, S0N, S4H, S0C, S4A, S0G</li>
            <li>
              Quebec: G8P, G0V, G0W, G0T, G0H, G0G, G5B, G0C, G4X, G0C, G0J, G5J, G4W, G4T, G0E, G5H, G0K, G5R, G0L, G5T, G5A, G8M, G8J, G8L, G8K,
              G8H, G8N, G7P, G7B, G7N, J1T, J0A, J1Z, J5V, J3T, J6E, J0R, J8C, J0T, J0K, J9L, J9E, J0X, J0W, J0M, J0Z, J9P, J0Y, J9P, J9T, J9Z, J0T,
              J0H
            </li>
            <li>Ontario: P0V, P9N, P8T, P8N, P0W, P0Y, P0X, P9A, P0T, P0L, P5N, J0T, N0G, K0C, N0L</li>
            <li>Newfoundland & Labrador: A0P, A0R, A2V, A0K, A0A, A0H, A0E, A0C</li>
            <li>Nova Scotia: B0E, B0S</li>
            <li>Prince Edward Island: C1B</li>
          </ul>
          <div class="spacer20"></div>
          <div class="header1">
            Furniture
          </div>
          <div class="spacer20"></div>
          <p>For our furniture delivery please contact our us at <a>info@babybryan.ca</a> for details before placing your order.</p>
          <p>
            We ask that you inspect all furniture pieces upon delivery. If the products arrive damaged please sign for the item as 'Damaged' and
            advise the driver. Please contact us by phone or email <a>info@babybryan.ca</a> and advise of the damages so that we can proceed from
            there.
          </p>
          <p>
            In the event of a manufacture defect, please contact us or the manufacturer ASAP and provide photos with damage/defect parts or other
            evidence. All manufacture defects must be reported no later than 2 business days from the date the item was received. We require our
            customers to take photos showcasing the damage/defect, a copy of the original receipt or copy of gift receipt, model number, manufacture
            date (if possible), and item description.
          </p>
        </div>
      </div>
      <div v-else-if="this.show_content == 'Returns & Exchanges'" class="box">
        <div class="spacer20"></div>
        <div class="body1">
          <div class="header1">
            Returns & Exchanges
          </div>
          <div class="spacer20"></div>
          <p style="color: red;">
            Due to healthy concerns regarding COVID-19, REFUNDS or EXCHANGES will not be accepted now!
          </p>
          <p>
            Baby Bryan offers 14-day return policy: within 7 days of your purchase date, you can receive
            a refund to the original method of payment or exchange your items or get store credit; after 
            7 days but within 14 days of your purchase date, you can only exchange your item or get store 
            credit. All returned or exchange items must be in original conditions and packages and tags, 
            unwashed, not used, not damaged, and with the original receipt. We will no longer accept any 
            refund or exchange after 14 days since your purchase date.
          </p>
          <p>
            Please note that the Following items are not returnable: sale items, special orders, clearance
            items, floor models, disassembled products, gift certificates, potty & potty accessories, soft 
            toys, car seats, strollers, pillows, baby carriers, breast pumps & related accessories, milk 
            bottles & nipples, undergarments, belly wraps, all electronic items. For All returns or exchange 
            of iLoom and iFam products, package must be in original conditions and items must not be used. 
            JellyCat is not returnable and exchangeable unless quality issues. Baby Bryan Reserves the right 
            to limit or deny any return and to change this policy without further notice.
          </p>
          <p>
            Clearance items are FINAL SALE.
          </p>
          <p>
            For safety, health & hygienic reasons, some products are final sale.
          </p>
          <p>
            These products include, but are not limited to:
          </p>
          <ul class="list">
            <li>Car seats & car seat bases</li>
            <li>Breast pumps & accessories</li>
            <li>Baby monitors that have Wi-Fi functionality</li>
            <li>Bath tubs & Bathing accessories</li>
            <li>Skin care products, tootbrushes & toothpaste once opened</li>
            <li>Safety gates once opened</li>
            <li>Potties</li>
            <li>Special Order & Pre-Order Items</li>
            <li>Clearance items</li>
            <li>Gift Cards</li>
            <li>Mattresses & Mattress Covers</li>
            <li>Furniture</li>
          </ul>
          <div class="spacer10"></div>
          <div class="header2">
            Special Orders
          </div>
          <p>
            All special order and furniture items are final sales and cannot be cancelled or refund or exchange. Special orders are items that we do
            not have in our inventory and have an estimated order lead time. Once the items have been paid and ordered, they cannot be returned and
            are a final sale. You will be informed of the estimated order time for your items prior to completing the special order. Delivery times
            are estimated and not guaranteed. Please note that estimates are given based on information given by the supplier; Baby Bryan is not
            responsible for supplier delays or back orders. As soon as the order arrives in store you will be contacted or it will be shipped to you.
          </p>
          <div class="header2">
            Cancellation Policy
          </div>
          <p>
            With our commitment to process online orders quickly, cancellation requests must be submitted within 24 hours from the time of order and
            must before we ship.
          </p>
          <p>
            Please contact us at <a>info@babybryan.ca</a> or call us with your cancellation requests. We will notify you if your order is eligible to
            be canceled. Please note that sending in a cancellation request does not confirm that your order has been canceled. Canceled orders will
            be confirmed in writing via email. In the event that your order cannot be canceled, please refer to our return policy.
          </p>
          <div class="header2">
            Return Authorization
          </div>
          <p>
            In order to return an item via mail or for online purchase requiring a refund (within the 14 day return policy), please contact our
            customer service team at <a>info@babybryan.ca</a>. Please note, refunds are issued once an item has been received and inspected by our
            customer service team member. Any items that are sent that do not meet the requirements of a return will still be seen as a sold item and
            a customer service representative will contact you.
          </p>
          <p>
            Please note a Return Request is only required if you are returning your online purchase or gift via mail or if you are requesting a refund
            instead of a credit or exchange. If you are exchanging your items to a store location or looking for a store credit only a receipt or gift
            receipt is required.
          </p>
          <div class="header2">
            Car Seats
          </div>
          <p>
            All car seats are final sale and cannot be returned or exchanged. This policy is in effect to ensure that these seats have not been
            compromised in any kind of altercation; whether a minor car accident, being dropped or being compressed under other items in a garage,
            etc. We take the safety of your children very seriously and will not risk compromising your child's safety with a car seat that has
            already been removed from the store. Should your car seat have a defect you must contact the manufacturer's customer service as it is
            their discretion on how the problem will be rectified and we will only take back a car seat if advised to do so by the manufacturer.
          </p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      aboutUsImages: [],
      show_content: "About Us",
      activeKey: 0,
    };
  },
  computed: {
    iOS_device() {
      return this.$store.getters.isIosWebBased;
    },
  },
  mounted() {
    this.$parent.curTab = 0;
    this.getAboutUsImages();
    var x = document.getElementById("aboutus");
    setTimeout(function () {
      x.style.display = "block";
    }, 100);
  },
  methods: {
    // ------------------------------------------------------------------------ getAboutUsImages
    getAboutUsImages() {
      let $this = this;
      $this.$ajax2
        .post("GetAboutImages", { AppVersion: this.$version }, $this.$ajaxHeader)
        .then(function (rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.aboutUsImages = rpdata.data.data;
          }
        })
        .catch(function (err) { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickChangeContent
    onClickChangeContent(data) {
      let $this = this;
      $this.show_content = data;
    },
    // ------------------------------------------------------------------------ onClickIOSTips
    onClickIOSTips() {
      this.$parent.popupHints = true;
    },
  },
};
</script>

<style scoped>
#aboutus {
  width: 100%;
  margin-bottom: 60px;
}

#aboutus .spacer10 {
  height: 10px;
  background-color: #ffffff;
}

#aboutus .spacer20 {
  height: 20px;
  background-color: #ffffff;
}

#aboutus .header1 {
  margin: auto;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}

#aboutus .header2 {
  margin: auto;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

#aboutus .body1 {
  margin: auto;
  width: 88%;
  line-height: 20px;
  font-size: 16px;
}

#aboutus .body1 .list {
  list-style-type: circle;
  line-height: 18px;
  font-size: 12px;
}

#aboutus img {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  /* padding: 3px;
  height: 98%;
  width: 100%; */
}

#aboutus .aboutUsContainer {
  display: flex;
}

#aboutus .box {
  flex-grow: 1;
  width: 80%;
}

#aboutus .sidebar {
  width: 15vh;
}</style>
